import FJMediaPreview from './FJMediaPreview';
import { useDispatch, useSelector } from 'react-redux';
import FJActionModal from '../../../redux/action/FJActionModal';
const FJMediaPreviewContainer = () => {
    const dispatch = useDispatch();
    const mediaPreviewData = useSelector(state => state.modals.mediaPreviewData);
    const closePanel = () => {
        dispatch(FJActionModal.closeMediaPreviewAction());
    };
    return <FJMediaPreview mediaPreviewData={mediaPreviewData} closePanel={closePanel} />;
};

export default FJMediaPreviewContainer;
